define("TavanoTeam.IndependentDealersForm.Router",
    ["IndependentDealersForm.View"],

    function(IndependentDealersFormView) {
    "use strict";

    var Router = Backbone.Router.extend({
        routes: {
            "independent-dealer-inquiries" : "independentDealerInquiries"
        },

        initialize: function(options) {
            this.application = options.application;
        },
        independentDealerInquiries: function() {

            var view = new IndependentDealersFormView({
                application: this.application
            });
            view.showContent();
        }
    });

    return Router;

});
